import { SelectedWork } from '@/components/sections/cv/SelectedWork'
import { Connect } from '@/components/sections/portfolio/Connect'
import { SEO } from '@/components/shared/SEO'
import { identity } from '@/content/portfolio'

export function Work() {
  return (
    <>
      <SEO
        title="Work — Will Tran"
        description="Products and platforms I built: employer work, AI products, independent side projects, and open-source tools. Roles, screenshots, outcomes, and evidence."
        url={`${identity.website}/work`}
      />
      <main id="main-content" tabIndex={-1} className="pt-28 lg:pt-32">
        <header className="mx-auto max-w-6xl px-4 pb-8 lg:px-8 lg:pb-10">
          <div className="section-label mb-4 text-accent-primary">Work</div>
          <div className="flex flex-col justify-between gap-5 sm:flex-row sm:items-end">
            <div>
              <h1 className="text-4xl lg:text-6xl font-medium tracking-tighter text-text-heading">Selected work</h1>
              <p className="mt-4 max-w-2xl text-lg leading-relaxed text-text-secondary">
                Products, systems, and the decisions behind them.
              </p>
            </div>
            <a
              href="#project-library"
              className="shrink-0 py-2 font-mono text-sm text-accent-primary underline underline-offset-4 hover:text-text-primary"
            >
              Browse all projects ↓
            </a>
          </div>
        </header>
        <SelectedWork />
        <Connect />
      </main>
    </>
  )
}
